// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"613d3e43","703":"080507eb","787":"47ed96d1"}[chunkId] + ".chunk.js";
};